import { path, propEq } from 'ramda'
import lodash from 'lodash'
import { getEventLink } from '@/store/modules/general-settings'

const escapeRegExpSymbols = '$*+^()[]{}|\''

const blitzInvitationModel = [
  {
    name: 'Company',
    description: 'Company name which admin entered in Invitation form, or Excel sheet'
  },
  {
    name: 'Name',
    description: 'Name of person which admin entered in Invitation form, or Excel sheet'
  },
  {
    name: 'Token',
    description: 'Token for generating unique URL to have access Blitz Registration Form. This token we will put in query param in url, we use this token to identify blitz participants. Name of query parameter is "token"'
  }
]

const forgotPasswordRequestModel = [
  {
    name: 'ResetPasswordToken',
    description: 'Speccial token which we will put in query param in url, we use this token to identify Attendee, name of query param is "token"'
  }
]

const enableVideoModel = [
  {
    name: 'Token',
    description: 'Token for generating unique URL to have access Video page. This token we will put in query param in url, we use this token to identify attendee. Name of query param is "token"'
  }
]

const registrationSuccessModel = [
  {
    name: 'BlitzInvitationToken',
    description: 'Token for generating unique URL to have access Blitz Registration Form. Name of query param is "token"'
  },
  {
    name: 'ListingInvitationToken',
    description: 'Token for generating unique URL to have access Listing Registration Form. Name of query param is "token"'
  },
  {
    name: 'FeaturedAttendeeInvitationToken',
    description: 'Token for generating unique URL to have access to Feature Attendee Form. Name of query param is "token"'
  },
  {
    name: 'Email',
    description: 'Email address of Attendee'
  },
  {
    name: 'BarcodeUrl',
    description: 'BarCode Image URL, you may use it as source for image tah in HTML. Src tag value should be "@Model.BarcodeUrl"'
  },
  {
    name: 'QrCodeUrl',
    description: 'QrCodeUrl Image URL, you may use it as source for image tah in HTML. Src tag value should be "@Model.QrCodeUrl"'
  },
  {
    name: 'FirstName',
    description: 'First Name of Attendee'
  },
  {
    name: 'LastName',
    description: 'Last Name of Attendee'
  },
  {
    name: 'PackageType',
    description: 'Type of package "Free" or "Paid"'
  },
  {
    name: 'UniqueId',
    description: 'Unique ID of Attendee'
  },
  {
    name: 'RegistrationInvitationToken',
    description: 'If it is Template for Vip Attendee, RegistrationInvitationToken it is part of unique link which we use on first step of registration. Name of query param for regular attendee is "invitationToken" and for VIP "token"'
  },
  {
    name: 'Company',
    description: 'Company Name of Attendee'
  },
  {
    name: 'ActivitiesList',
    description: 'List(Array) of activities inside package of Attendee'
  },
  {
    name: 'VoucherToken',
    description: 'Token for generating unique URL to have access to Feature Attendee Form'
  }
]

const attendeeMessageModel = [
  {
    name: 'SenderEmail',
    description: 'Email address of attendee who sent message'
  },
  {
    name: 'Message',
    description: 'Text of message'
  },
  {
    name: 'SenderFirstName',
    description: 'Fitstname of attendee who sent mesage'
  },
  {
    name: 'SenderLastName',
    description: 'Lastname of attendee who sent mesage'
  },
  {
    name: 'SenderCompany',
    description: 'Name of COmpany of attendee who sent mesage'
  },
  {
    name: 'SenderJobTitle',
    description: 'Job Title of attendee who sent mesage'
  }
]

const contactUsModel = [
  {
    name: 'Email',
    description: 'Email address of attendee who sent message'
  },
  {
    name: 'FirstName',
    description: 'Fitst name of attendee who sent mesage'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee who sent mesage'
  },
  {
    name: 'Message',
    description: 'Text of message'
  },
  {
    name: 'PhoneNumber',
    description: 'Phonenumber of attendee who sent mesage'
  },
  {
    name: 'InterestType',
    description: 'Type of interest'
  }
]

const confirmationEmailModel = [
  {
    name: 'Token',
    description: 'Speccial token which we will put in query param in url, we use this token to identify Attendee, name of query param is "token"'
  }
]

const vipInvitationModel = [
  {
    name: 'Slug',
    description: 'Slug which admin enter in invitation form. For url which look like: https://url.com/registration/slug/code'
  },
  {
    name: 'Code',
    description: 'Code which admin enter in invitation form. For url which look like: https://url.com/registration/slug/code'
  }
]

const attendeeBlockedModel = [
  {
    name: 'FirstName',
    description: 'First name of attendee who was blocked'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee who was blocked'
  },
  {
    name: 'Company',
    description: 'Company name of attendee who was blocked'
  },
  {
    name: 'AttendeeType',
    description: 'Type (vip or regular) of attendee who was blocked'
  }
]

const requestForPhotoModel = [
  {
    name: 'Token',
    description: 'Speccial token which we will put in query param in url, we use this token to identify Attendee, name of query param is "token"'
  },
  {
    name: 'FirstName',
    description: 'First name of attendee which need to upgrade photo'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee which need to upgrade photo'
  }
]

const requestForPaymentModel = [
  {
    name: 'Token',
    description: 'Speccial token which we will put in query param in url, we use this token to identify Attendee, name of query param is "token"'
  },
  {
    name: 'FirstName',
    description: 'First name of attendee which need to upgrade package'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee which need to upgrade package'
  },
  {
    name: 'PackageName',
    description: 'Name of package which attendee has right now'
  },
  {
    name: 'PackageTitle',
    description: 'Title of package which attendee has right now'
  },
  {
    name: 'PackagePrice',
    description: 'Price of package which attendee has right now'
  }
]

const reminderModel = [
  {
    name: 'FirstName',
    description: 'First name of attendee'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee'
  },
  {
    name: 'Company',
    description: 'Company name of attendee'
  },
  {
    name: 'AttendeeType',
    description: 'Type (vip or regular) of attendee'
  }
]

const listingModel = [
  {
    name: 'Company',
    description: 'Company name of Participant'
  },
  {
    name: 'Name',
    description: 'Name of Participant'
  },
  {
    name: 'Token',
    description: 'Speccial token which we will put in query param in url, we use this token to identify Attendee, name of query param is "token"'
  }
]

const blitzSubmitedModel = [
  {
    name: 'BlitzBody',
    description: 'Complex object which contatins all fields that attendee enter in form. Name of keys inside BlitzBody you may check in field with name "property" inside of settings of BlitzForm'
  }
]

const listingSubmittedModel = [
  {
    name: 'ListingBody',
    description: 'Complex object which contatins all fields that attendee enter in form. Name of keys inside ListingBody you may check in field with name "property" inside of settings of ListingForm'
  }
]

const registrationStatusChangedModel = [
  {
    name: 'Id',
    description: 'Id of attendee'
  },
  {
    name: 'Email',
    description: 'Email of attendee'
  },
  {
    name: 'BirthYear',
    description: 'Birth Year of attendee'
  },
  {
    name: 'FirstName',
    description: 'First name of attendee'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee'
  },
  {
    name: 'UniqueCode',
    description: 'Unique code of attendee'
  },
  {
    name: 'UniqueId',
    description: 'Unique Id of attendee'
  },
  {
    name: 'Company',
    description: 'Company name of attendee'
  },
  {
    name: 'MessagesCount',
    description: 'Message count inside attendee package'
  },
  {
    name: 'AttendeeType',
    description: 'Type of attendee (VIP or regular)'
  },
  {
    name: 'RegistrationStatus',
    description: 'New registration status of attendee'
  },
  {
    name: 'JobTitle',
    description: 'Job Title of attendee'
  },
  {
    name: 'UserName',
    description: 'User who exported attendee list'
  },
  {
    name: 'UserEmail',
    description: 'User\'s email who send error report'
  },
  {
    name: 'RequestId',
    description: 'RequestId of request'
  },
  {
    name: 'AdditionalErrorBody',
    description: 'Additional list of errors'
  },
  {
    name: 'Message',
    description: 'Text of error message'
  },
  {
    name: 'Date',
    description: 'Date when error happened'
  }
]

const invoiceMessageModel = [
  {
    name: 'Type',
    description: 'Type of attendee (VIP or regular)'
  },
  {
    name: 'Address',
    description: 'Address of attendee'
  },
  {
    name: 'Name',
    description: 'Name of attendee'
  },
  {
    name: 'State',
    description: 'State of living of attendee'
  },
  {
    name: 'UniqueId',
    description: 'UniqueId of attendee'
  },
  {
    name: 'Title',
    description: 'Title of Invoice'
  },
  {
    name: 'Package',
    description: 'Package Name of attendee'
  },
  {
    name: 'Price',
    description: 'Price of package'
  },
  {
    name: 'Amount',
    description: 'Amount of money to paid'
  },
  {
    name: 'VatText',
    description: 'Vat Id description'
  },
  {
    name: 'VatId',
    description: 'VAT ID value of attendee'
  },
  {
    name: 'Id',
    description: 'Id of attendee'
  },
  {
    name: 'ApprovalDate',
    description: 'Date of buy of package'
  },
  {
    name: 'Quantity',
    description: 'Quantity of packages to buy by attendee'
  },
  {
    name: 'Provider',
    description: 'Payment provider (Paypal or BlueSnap)'
  }
]

const featureFromRequestModel = [
  {
    name: 'Token',
    description: 'Speccial token which we will put in query param in url, we use this token to identify Attendee, name of query param is "token"'
  },
  {
    name: 'FirstName',
    description: 'First name of attendee'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee'
  }
]

const passwordSettingModel = [
  {
    name: 'ResetPasswordToken',
    description: 'We use this token to give admin ability to set or reset password'
  }
]

const IPNSendingModel = [
  {
    name: 'PaymentDate',
    description: 'Date of payment'
  },
  {
    name: 'PaymentTime',
    description: 'Time of payment'
  },
  {
    name: 'PaymentTransactionId',
    description: 'Id of payment transaction'
  },
  {
    name: 'PaymentProvider',
    description: 'Payment provider'
  },
  {
    name: 'FirstName',
    description: 'First name of attendee'
  },
  {
    name: 'LastName',
    description: 'Last name of attendee'
  },
  {
    name: 'EmailAddress',
    description: 'Email address'
  },
  {
    name: 'Company',
    description: 'Company'
  },
  {
    name: 'Country',
    description: 'Country'
  },
  {
    name: 'Address',
    description: 'Address'
  },
  {
    name: 'EventName',
    description: 'Name of event'
  },
  {
    name: 'Phone',
    description: 'Phone number'
  },
  {
    name: 'PackageName',
    description: 'Name of package'
  },
  {
    name: 'PackageTitle',
    description: 'Title of package'
  },
  {
    name: 'TicketsQuantity',
    description: 'Quantity of tickets'
  },
  {
    name: 'PackagePrice',
    description: 'Price of package'
  },
  {
    name: 'Currency',
    description: 'Currency of payment'
  },
  {
    name: 'Discount',
    description: 'Discount'
  },
  {
    name: 'VatId',
    description: 'VatId'
  },
  {
    name: 'TaxAmount',
    description: 'Tax Amount'
  },
  {
    name: 'FinalPaidPrice',
    description: 'Final price'
  },
  {
    name: 'TransactionType',
    description: 'Type of transaction'
  }
]

const sponsorCreatedModel = [
  {
    name: 'ContactPersonName',
    description: 'Name of person to contatct with inside sponsor organisation'
  },
  {
    name: 'CompanyName',
    description: 'Name of sponsors company'
  }
]

export const emailTempateCategories = [
  {
    id: 'IPN',
    category: 'IPN',
    description: 'This email template will be used to send message for IPN & IPN refund',
    title: 'IPN',
    model: IPNSendingModel
  },
  {
    id: 'blitzInvitation',
    category: 'BlitzInvitation',
    description: 'This email template will be used to send message for Networking & Blitz Invitation',
    title: 'Blitz Invitation',
    model: blitzInvitationModel
  },
  {
    id: 'featuredAttendeeInvitation',
    category: 'FeaturedAttendeeInvitation',
    description: 'Template for Invitation Attendee to add featured info, like Photo and Company Logo',
    title: 'Featured Attendee Invitation',
    model: featureFromRequestModel
  },
  {
    id: 'requestForPayment',
    category: 'RequestForPayment',
    description: 'Template for Upgrade package for regular Attendee',
    title: 'Request for Payment',
    model: requestForPaymentModel
  },
  {
    id: 'requestForPhoto',
    category: 'AttendeeSubmitImage',
    description: 'Template for Upgrade photo for Attendee',
    title: 'Attendee Submit Image',
    model: requestForPhotoModel
  },
  {
    id: 'forgotPasswordRequest',
    category: 'ForgotPasswordRequest',
    description: 'Template to send unique link when user submin email in forgot passowrd form',
    title: 'Forgot Password Request',
    model: forgotPasswordRequestModel
  },
  {
    id: 'vipRegistrationInvitation',
    category: 'VipRegistrationInvitation',
    description: 'Template for Vip Attendee invitation',
    title: 'Vip Registration Invitation',
    model: vipInvitationModel
  },
  {
    id: 'registrationSuccess',
    category: 'RegistrationSuccess',
    description: 'Template for completion Attendee registration',
    title: 'Success Registration',
    model: registrationSuccessModel
  },
  {
    id: 'invoices',
    category: 'Invoices',
    description: 'Template to receive invoice via Email',
    title: 'Invoices',
    model: invoiceMessageModel
  },
  {
    id: 'listingInvitation',
    category: 'ListingInvitation',
    description: 'Template for sending Invitation to Event Listing',
    title: 'Listing Invitation',
    model: listingModel
  },
  {
    id: 'remind',
    category: 'Remind',
    description: 'Templates for sending different types of reminders to Attendees',
    title: 'Attendee Reminder',
    model: reminderModel
  },
  {
    id: 'adminNotifications',
    category: 'AdminNotifications',
    description: 'Template for sending messages to administrator',
    title: 'Admin notifications',
    model: registrationStatusChangedModel
  },
  {
    id: 'attendeeNotifications',
    category: 'AttendeeNotifications',
    description: 'Template for sending messages to Attendee',
    title: 'Attendee notifications',
    model: registrationStatusChangedModel
  },
  {
    id: 'attendeeBlockedMessage',
    category: 'AttendeeBlockedMessage',
    description: 'Template for notification Attendee if his/her account was blocked',
    title: 'Attendee blocked message',
    model: attendeeBlockedModel
  },
  {
    id: 'attendeeConfirmation',
    category: 'AttendeeConfirmation',
    title: 'Attendee confirmation',
    model: confirmationEmailModel
  },
  {
    id: 'attendeeMessage',
    category: 'AttendeeMessage',
    title: 'Attendee message',
    model: attendeeMessageModel
  },
  {
    id: 'blitzSubmitted',
    category: 'BlitzSubmitted',
    title: 'Blitz submitted',
    model: blitzSubmitedModel
  },
  {
    id: 'contactUs',
    category: 'ContactUs',
    title: 'Contact us',
    model: contactUsModel
  },
  {
    id: 'invoiceRefundSending',
    category: 'InvoiceRefundSending',
    title: 'Invoice refund sending',
    model: invoiceMessageModel
  },
  {
    id: 'listingSubmitted',
    category: 'ListingSubmitted',
    title: 'Listing submitted',
    model: listingSubmittedModel
  },
  {
    id: 'mediaKit',
    category: 'MediaKit',
    description: 'Template to send MediaKit PDF to Sponsor',
    title: 'Sending Media Kit',
    model: sponsorCreatedModel
  },
  {
    id: 'enableVideoRequest',
    category: 'EnableVideoRequest',
    description: 'Template for Invitation on Video Page',
    title: 'Enable Video Request',
    model: enableVideoModel
  },
  {
    id: 'resetPassword',
    category: 'ResetPassword',
    description: 'Template for Set or Reset admin password',
    title: 'ResetPassword',
    model: passwordSettingModel
  },
  // TODO: Don't have model
  {
    id: 'registrationFailture',
    category: 'RegistrationFailture',
    description: 'Template for notification about failture during payment process',
    title: 'Failture Registration',
    model: []
  },
  {
    id: 'forgotPasswordSuccess',
    category: 'ForgotPasswordSuccess',
    description: 'Template to send when Attendee successfully changed the Password',
    title: 'Forgot Password Success',
    model: []
  },
  {
    id: 'multipleTicketsSuccessBuy',
    category: 'MultipleTicketsSuccessBuy',
    description: 'Template for completion Attendee registration, in case purchase more than 1 ticket',
    title: 'Multiple Tickets success buy',
    model: registrationSuccessModel
  },
  {
    id: 'multipleTicketsFailedBuy',
    category: 'MultipleTicketsFailedBuy',
    description: 'Template for notification about failture during payment process, in case purchase more than 1 ticket',
    title: 'Multiple Tickets failed buy',
    model: []
  },
  {
    id: 'registrationCompanyUpdates',
    category: 'RegistrationCompanyUpdates',
    description: 'Template for Newsletter about Company news and updates',
    title: 'Registration company updates',
    model: []
  },
  {
    id: 'registrationProductUpdates',
    category: 'RegistrationProductUpdates',
    description: 'Template for Newsletter about Product news and updates',
    title: 'Registration product updates',
    model: []
  },
  {
    id: 'awardsVoitingCompleated',
    category: 'AwardsVoitingCompleated',
    description: 'Template for Awads Vote one and Vote Two after succssesfuly submited',
    title: 'Awards Voiting Compleated',
    model: []
  }
]

export const categoriesMap = emailTempateCategories.reduce((acc, categoryObj) => {
  acc[categoryObj.id] = categoryObj
  return acc
}, {})

export function generateEmailTemplateListById (idInCategoriesMap, templateList) {
  return function generateTemplateList () {
    if (!Array.isArray(this.getEmailTemplates)) return []

    const templates = this.getEmailTemplates.filter(template => {
      const category = path(
        [idInCategoriesMap, 'category'],
        categoriesMap
      )
      return propEq('category', category, template)
    })
    return templates
  }
}

/* eslint-disable */
export function generateCodeOfHeader (imageName) {
  return `<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">
          <html xmlns=\"http://www.w3.org/1999/xhtml\" lang=\"en\" xml:lang=\"en\" style=\"background:#f3f3f3!important\">
          <head>
            <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">
            <meta name=\"viewport\" content=\"width=device-width\">
            <title></title>
            <style>@media only screen{html{min-height:100%;background:#f3f3f3}}@media only screen and (max-width:596px){th.small-1{display:inline-block!important;width:8.33333%!important}}</style>
          </head>
          <body style=\"-moz-box-sizing:border-box;-ms-text-size-adjust:100%;-webkit-box-sizing:border-box;-webkit-text-size-adjust:100%;Margin:0;background:#f3f3f3!important;box-sizing:border-box;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0;min-width:100%;padding:0;text-align:left;width:100%!important\">
          <a class=\"primary\" href=\"${getEventLink()}/\" style=\"Margin:0;color:#2199e8;font-family:Helvetica,Arial,sans-serif;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left;text-decoration:none\">
            <img class=\"float-center\" src=\"https://res.cloudinary.com/finance-magnates/image/upload/v1580294072/Header_no-01-1.jpg\" style=\"-ms-interpolation-mode:bicubic;Margin:0 auto;border:none;clear:both;display:block;float:none;margin:0 auto;max-width:100%;outline:0;text-align:center;text-decoration:none;width:auto\">
          </a>
          <table class=\"main-container body-color-container\" style=\"background-color:#fff;border-collapse:collapse;border-spacing:0;margin:0 auto;max-width:600px;padding:0;text-align:left;vertical-align:top;width:100%\">
            <tr style=\"padding:0;text-align:left;vertical-align:top\">
              <td class=\"center body-space-wrapper\" align=\"center\" valign=\"top\" style=\"-moz-hyphens:auto;-webkit-hyphens:auto;Margin:0;border-collapse:collapse!important;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;hyphens:auto;line-height:1.3;margin:0;padding:16px;text-align:left;vertical-align:top;word-wrap:break-word\">
              <div class=\"cool-divider\"></div>`
}

export function generateCodeOfFooter () {
  return `<div class=\"cool-divider\"></div>
        </td></tr></table><table class=\"main-container footer-container\" style=\"background: #3d3d3c; border-top: 7px solid #e74456; border-collapse:collapse;border-spacing:0;margin:0 auto;max-width:600px;padding:0;text-align:left;vertical-align:top;width:100%\"><tr style=\"padding:0;text-align:left;vertical-align:top\"><td class=\"center body-space-wrapper footer-text\" align=\"center\" valign=\"top\" style=\"-moz-hyphens:auto;-webkit-hyphens:auto;Margin:0;border-collapse:collapse!important;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;hyphens:auto;line-height:1.3;margin:0;padding:16px;text-align:left;vertical-align:top;word-wrap:break-word\"><p style=\"Margin:0;Margin-bottom:10px;color:#fff;font-family:Arial,Helvetica,sans-serif;font-size:15px;font-weight:400;line-height:1.3;margin:0;margin-bottom:30px;padding:0;text-align:center\"><a class=\"primary\" href=\"${getEventLink()}/\" style=\"Margin:0;color:#2199e8;font-family:Helvetica,Arial,sans-serif;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left;text-decoration:none\"><img class=\"float-center\" src=\"https://res.cloudinary.com/finance-magnates/image/upload/v1565695620/jcpdxsot0yhgsvvbohif.png\" alt=\"FMEvents Footer logo\" style=\"-ms-interpolation-mode:bicubic;Margin:0 auto;border:none;clear:both;display:block;float:none;margin:0 auto;max-width:100%;outline:0;text-align:center;text-decoration:none;width:80px\"></a></p><!-- START OF DESCTOP ICONS BLOCK --><table align=\"center\" class=\"row footer-icons-set\" style=\"border-collapse:collapse;border-spacing:0;padding:0;position:relative;text-align:left;vertical-align:top;width:100%\"><tbody><tr style=\"padding:0;text-align:center;vertical-align:top\">

        <th class=\"small-1 large-2 columns first\" style=\"Margin:0 auto;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0 auto;padding:0;padding-bottom:16px;padding-left:16px;padding-right:8px;text-align:left;width:80.67px\"><table style=\"border-collapse:collapse;border-spacing:0;padding:0;text-align:left;vertical-align:top;width:100%\">
        <tr style=\"padding:0;text-align:center;vertical-align:top\"><th style=\"Margin:0;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left\"><a class=\"primary\" href=\"https://www.facebook.com/iFXEXPO/\" style=\"Margin:0;color:#2199e8;font-family:Helvetica,Arial,sans-serif;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left;text-decoration:none\"><img class=\"float-center\" src=\"https://res.cloudinary.com/finance-magnates/image/upload/v1571911721/g59915.png\" alt=\"facebook logo\" style=\"-ms-interpolation-mode:bicubic;Margin:0 auto;border:none;clear:both;display:block;float:none;margin:0 auto;max-width:100%;outline:0;text-align:center;text-decoration:none;width:auto\"></a></th></tr></table></th>

        <th class=\"small-1 large-2 columns\" style=\"Margin:0 auto;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0 auto;padding:0;padding-bottom:16px;padding-left:8px;padding-right:8px;text-align:left;width:80.67px\"><table style=\"border-collapse:collapse;border-spacing:0;padding:0;text-align:left;vertical-align:top;width:100%\"><tr style=\"padding:0;text-align:center;vertical-align:top\"><th style=\"Margin:0;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left\"><a class=\"primary\" href=\"https://twitter.com/ifxexpo\" style=\"Margin:0;color:#2199e8;font-family:Helvetica,Arial,sans-serif;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left;text-decoration:none\"><img class=\"float-center\" src=\"https://res.cloudinary.com/finance-magnates/image/upload/v1571911721/g59919.png\" alt=\"twitter logo\" style=\"-ms-interpolation-mode:bicubic;Margin:0 auto;border:none;clear:both;display:block;float:none;margin:0 auto;max-width:100%;outline:0;text-align:center;text-decoration:none;width:auto\"></a></th></tr></table></th>

        <th class=\"small-1 large-2 columns\" style=\"Margin:0 auto;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0 auto;padding:0;padding-bottom:16px;padding-left:8px;padding-right:8px;text-align:left;width:80.67px\"><table style=\"border-collapse:collapse;border-spacing:0;padding:0;text-align:left;vertical-align:top;width:100%\"><tr style=\"padding:0;text-align:center;vertical-align:top\"><th style=\"Margin:0;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left\"><a class=\"primary\" href=\"https://www.youtube.com/user/iFXEXPO\" style=\"Margin:0;color:#2199e8;font-family:Helvetica,Arial,sans-serif;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left;text-decoration:none\"><img class=\"float-center\" src=\"https://res.cloudinary.com/finance-magnates/image/upload/v1571911721/g59943.png\" alt=\"youtube logo\" style=\"-ms-interpolation-mode:bicubic;Margin:0 auto;border:none;clear:both;display:block;float:none;margin:0 auto;max-width:100%;outline:0;text-align:center;text-decoration:none;width:auto\"></a></th></tr></table></th>

        <th class=\"small-1 large-2 columns last\" style=\"Margin:0 auto;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0 auto;padding:0;padding-bottom:16px;padding-left:8px;padding-right:16px;text-align:left;width:80.67px\"><table style=\"border-collapse:collapse;border-spacing:0;padding:0;text-align:left;vertical-align:top;width:100%\"><tr style=\"padding:0;text-align:center;vertical-align:top\"><th style=\"Margin:0;color:#0a0a0a;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left\"><a class=\"primary\" href=\"https://www.linkedin.com/company/ifxexpo\" style=\"Margin:0;color:#2199e8;font-family:Helvetica,Arial,sans-serif;font-weight:400;line-height:1.3;margin:0;padding:0;text-align:left;text-decoration:none\"><img class=\"float-center\" src=\"\https://res.cloudinary.com/finance-magnates/image/upload/v1571911721/path59935.png\" alt=\"linkedin logo\" style=\"-ms-interpolation-mode:bicubic;Margin:0 auto;border:none;clear:both;display:block;float:none;margin:0 auto;max-width:100%;outline:0;text-align:center;text-decoration:none;width:auto\"></a></th></tr></table></th>

        </tr></tbody></table><!-- END OF DESCTOP ICONS BLOCK --><p class=\"copyright-text\" style=\"Margin:0;Margin-bottom:10px;color:#fff;font-family:Arial,Helvetica,sans-serif;font-size:15px;font-weight:400;line-height:1.3;margin:0;margin-bottom:10px;padding:0;padding-top:25px;text-align:center\">Copyright © 2019 \"iFX EXPO\" All rights reserved.</p><p style=\"Margin:0;Margin-bottom:10px;color:#fff;font-family:Arial,Helvetica,sans-serif;font-size:15px;font-weight:400;line-height:1.3;margin:0;margin-bottom:10px;padding:0;text-align:center\"><a href=\"${getEventLink()}/terms-and-conditions\" style=\"color:#fff;font-weight:600;\">Terms and Conditions</a></p><p style=\"Margin:0;Margin-bottom:10px;color:#fff;font-family:Arial,Helvetica,sans-serif;font-size:12px;font-weight:400;line-height:1.3;margin:0;margin-bottom:10px;padding:0 30px;text-align:center\"> If you no longer wish to receive these emails, please reply to this message and let us know.</p></td></tr></table><!-- prevent Gmail on iOS font size manipulation --><div style=\"display:none;white-space:nowrap;font:15px courier;line-height:0\">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</div></body></html>`
}

export function escaping (body) {
  if (!body) return body
  const regExpArray = escapeRegExpSymbols.split('').map(v => `(\\${v})`)
  const regex = RegExp(`${regExpArray.join('|')}`, 'gm')
  return regex.test(body) ? body.replace(/@media/gm, '@@media').replace(regex, '$&') : body
}

export function unescaping (body) {
  if (!body) return body
  body = lodash.unescape(body)
  const regExpArray = escapeRegExpSymbols.split('').map(simvol => `(\\\\${simvol})`)
  const regex = RegExp(`${regExpArray.join('|')}`, 'gm')
  const deleteBackspace = regex.test(body) ? body.replace(regex, coincidence => coincidence.replace(/\\/g, '')) : body
  return deleteBackspace.replace(/@@media/gm, '@media')
}



// WEBPACK FOOTER //
// ./src/utils/emailTemplates.js